export default "__VITE_ASSET__Vad07gAY__"